(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wh-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = (document.currentScript && document.currentScript.closest('.wh-blog')) || document.querySelector('.wh-blog');
  if (!root) root = document.querySelector('.wh-blog');
  if (!root) return;
  var filters = root.querySelectorAll('[data-wh-blog-cat]');
  var items = root.querySelectorAll('[data-wh-blog-item]');
  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cat = btn.getAttribute('data-wh-blog-cat');
      filters.forEach(function (f) { f.classList.remove('is-active'); });
      btn.classList.add('is-active');
      items.forEach(function (it) {
        var show = (cat === 'All') || (it.getAttribute('data-wh-blog-itemcat') === cat);
        it.classList.toggle('is-hidden', !show);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-event-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    var s = (document.currentScript && document.currentScript.closest('.wh-event-calculator')) || document.querySelector('.wh-event-calculator');
    if (!s) return false;
    if (s.__whCalcInit) return true;
    s.__whCalcInit = true;
    var root = s;

    // ---------- Config: read the Liquid-rendered JSON, never hardcode ----------
    var CFG = {};
    try { CFG = JSON.parse(root.querySelector('[data-wh-calc-data]').textContent); } catch (e) { CFG = {}; }
    var SEASONS = CFG.seasons || [];
    var VENUE_STYLES = CFG.styles || [];
    var CATERING_PACKAGES = CFG.packages || [];
    var ENTREES = CFG.entrees || [];
    var BEVERAGE_PACKAGES = CFG.beverages || [];
    var CATERING_ADDONS = CFG.addons || [];
    var FLORAL_PACKAGES = CFG.florals || [];
    var PREMIUM_SERVICES = CFG.premiums || [];
    var STEPS = CFG.steps || [];
    var RATES = CFG.rates || {};
    var LIM = CFG.limits || {};
    var C = CFG.copy || {};
    var SUB = CFG.submit || {};
    if (!STEPS.length || !VENUE_STYLES.length) return true;

    var CEREMONY_FEE = Number(RATES.ceremonyFee) || 0;
    var SERVICE_FEE_RATE = Number(RATES.serviceFee) || 0;
    var SALES_TAX_RATE = Number(RATES.salesTax) || 0;
    var APPETIZER_PP = Number(RATES.appetizerPP) || 0;
    var APPETIZER_DEFAULT_COUNT = Number(RATES.appetizerDefaultCount) || 0;
    var FAMILY_STYLE_FEE = Number(RATES.familyStyleFee) || 0;
    var DEFAULT_ENTREE = RATES.defaultEntree || '';

    // "{pct}" in a fee/tax label is replaced by the live rate, so the label can never drift from the math.
    function pctLabel(label, rate) {
      var pct = Math.round(Number(rate) * 100 * 1000) / 1000;
      return String(label || '').replace('{pct}', String(pct));
    }
    RATES.serviceLabel = pctLabel(RATES.serviceLabel, SERVICE_FEE_RATE);
    RATES.taxLabel = pctLabel(RATES.taxLabel, SALES_TAX_RATE);

    // Small fixed lists live in textarea settings (Shopify caps a section at 50 blocks):
    // one item per line, fields separated by "|".
    function rows(raw) {
      return String(raw || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
        .map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); });
    }
    function slug(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    // id|Name|note
    var SERVICE_STYLES = rows(CFG.serviceStylesRaw).map(function (r) {
      return r.length > 1 ? { id: r[0], name: r[1], note: r[2] || '' } : { id: slug(r[0]), name: r[0], note: '' };
    });
    // id|Name
    var APPETIZERS = rows(CFG.appetizersRaw).map(function (r) {
      return r.length > 1 ? { id: r[0], name: r[1] } : { id: slug(r[0]), name: r[0] };
    });

    // Package kind (select) → the boolean flags the React data uses.
    CATERING_PACKAGES.forEach(function (p) {
      var k = p.kind || 'tiered';
      p.outside = k === 'outside';
      p.customPricing = k === 'custom';
      p.appetizerPick = k === 'appetizer';
      p.flatPerGuest = k === 'flat' ? (Number(p.flatPerGuest) || 0) : 0;
      p.tiered = k === 'tiered';
      p.platedOnly = !!p.platedOnly;
      p.outsideFlat = Number(p.outsideFlat) || 0;
      p.entreesRequired = Number(p.entreesRequired) || 0;
    });

    // PRICE_MATRIX[style][packageId][entreeId], rebuilt from the entrée blocks' price settings.
    var PRICE_MATRIX = { buffet: { hearth: {}, legacy: {} }, plated: { hearth: {}, legacy: {}, 'grand-friar': {} } };
    function putPrice(style, pkgId, id, v) { if (v === null || v === undefined || v === '') return; PRICE_MATRIX[style][pkgId][id] = Number(v); }
    ENTREES.forEach(function (e) {
      putPrice('buffet', 'hearth', e.id, e.buffetHearth);
      putPrice('buffet', 'legacy', e.id, e.buffetLegacy);
      putPrice('plated', 'hearth', e.id, e.platedHearth);
      putPrice('plated', 'legacy', e.id, e.platedLegacy);
      putPrice('plated', 'grand-friar', e.id, e.platedGrandFriar);
    });

    // Average per-person entrée price for a tiered package given service style + selections
    function entreeAvgFor(pkgId, serviceStyle, entreeIds) {
      var key = serviceStyle === 'family' ? 'buffet' : (serviceStyle || 'buffet');
      var matrix = (PRICE_MATRIX[key] && PRICE_MATRIX[key][pkgId]) || PRICE_MATRIX.plated[pkgId] || {};
      var chosen = (entreeIds || []).filter(function (id) { return matrix[id] != null; });
      var tiers = chosen.length ? chosen : [DEFAULT_ENTREE];
      return tiers.reduce(function (s, id) { return s + matrix[id]; }, 0) / tiers.length;
    }
    function serviceStyleName(pkg, styleId) {
      if (pkg && pkg.platedOnly) { var pl = find(SERVICE_STYLES, 'plated'); return pl ? pl.name : 'Plated'; }
      return (find(SERVICE_STYLES, styleId || 'buffet') || {}).name;
    }
    var GUEST_MIN = Number(LIM.guestMin) || 8;
    var GUEST_MAX = Number(LIM.guestMax) || 200;
    var GUEST_STEP = Number(LIM.guestStep) || 2;
    var DUR_MAX = Number(LIM.durMax) || 12;

    SEASONS.forEach(function (x) {
      x.mult = Number(x.mult) || 0;
      x.nums = String(x.monthNums || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return !isNaN(n); });
    });
    function seasonByKey(k) { for (var i = 0; i < SEASONS.length; i++) { if (SEASONS[i].key === k) return SEASONS[i]; } return null; }
    function seasonForDate(iso) {
      if (!SEASONS.length) return { key: '', label: '', months: '', mult: 1, color: '#B7995C' };
      if (!iso) return seasonByKey('peak') || SEASONS[0];
      var m = new Date(iso).getUTCMonth() + 1;
      for (var i = 0; i < SEASONS.length; i++) { if (SEASONS[i].nums.indexOf(m) > -1) return SEASONS[i]; }
      return SEASONS[SEASONS.length - 1];
    }

    function find(arr, id) { for (var i = 0; i < arr.length; i++) { if (arr[i].id === id) return arr[i]; } return null; }
    function lines(str) { return String(str || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }

    // ---------- Quote math (port of data/calculator.js computeQuote) ----------
    function computeQuote(state) {
      var style = find(VENUE_STYLES, state.venueStyle);
      var season = seasonForDate(state.eventDate);
      var cateringPkg = find(CATERING_PACKAGES, state.cateringPackage);
      var beverage = find(BEVERAGE_PACKAGES, state.beveragePackage);
      var floral = find(FLORAL_PACKAGES, state.floralPackage);

      var guests = Math.max(0, Number(state.guestCount) || 0);
      var hours = Math.max((style && style.minHours) || 3, Number(state.durationHours) || 3);

      var hourly = style ? Math.round(style.hourly * season.mult) : 0;
      var venue = style ? hourly * hours : 0;

      // Catering (deck-accurate pricing)
      var catering = 0, entreeAvg = 0;
      if (cateringPkg) {
        if (cateringPkg.outside) { catering = cateringPkg.outsideFlat; }
        else if (cateringPkg.customPricing) { catering = 0; }
        else if (cateringPkg.appetizerPick) {
          var n = (state.appetizers || []).length || APPETIZER_DEFAULT_COUNT; // 3+ recommended
          catering = APPETIZER_PP * n * guests;
        } else if (cateringPkg.flatPerGuest) {
          catering = cateringPkg.flatPerGuest * guests;
        } else if (cateringPkg.tiered) {
          var styleKey = cateringPkg.platedOnly ? 'plated' : (state.serviceStyle || 'buffet');
          entreeAvg = entreeAvgFor(cateringPkg.id, styleKey, state.entrees);
          var familyFee = styleKey === 'family' ? FAMILY_STYLE_FEE : 0;
          catering = (entreeAvg + familyFee) * guests;
        }
      }

      var bev = beverage ? beverage.pp * guests : 0;

      var addOns = (state.cateringAddOns || []).reduce(function (sum, id) {
        var a = find(CATERING_ADDONS, id);
        if (!a) return sum;
        return sum + (a.flat ? a.flat : a.pp * guests);
      }, 0);

      var ceremony = state.ceremony ? CEREMONY_FEE : 0;
      var florals = floral ? floral.price : 0;
      var premium = (state.premiumServices || []).reduce(function (sum, id) {
        var p = find(PREMIUM_SERVICES, id);
        return sum + (p ? p.price : 0);
      }, 0);

      var serviceFee = (catering + bev) * SERVICE_FEE_RATE;
      var taxableSubtotal = venue + catering + bev + addOns + ceremony + florals + serviceFee;
      var salesTax = taxableSubtotal * SALES_TAX_RATE;
      var total = taxableSubtotal + salesTax + premium;

      return {
        style: style, season: season, cateringPkg: cateringPkg, beverage: beverage, floral: floral,
        hours: hours, hourly: hourly, guests: guests, entreeAvg: entreeAvg,
        lines: {
          venue: { label: (style ? style.name : 'Venue') + ' (' + hours + 'hr)', amount: venue },
          catering: {
            label: cateringPkg
              ? (cateringPkg.tiered ? cateringPkg.name + ' · ' + serviceStyleName(cateringPkg, state.serviceStyle) : cateringPkg.name)
              : 'Catering',
            amount: catering
          },
          beverage: { label: (beverage && beverage.pp > 0) ? beverage.name : null, amount: bev },
          addOns: { label: addOns > 0 ? 'Catering Add-Ons' : null, amount: addOns },
          ceremony: { label: ceremony > 0 ? (RATES.ceremonyLine || '') : null, amount: ceremony },
          florals: { label: floral ? floral.name + ' Florals' : null, amount: florals },
          premium: { label: premium > 0 ? 'Premium Services (non-taxable)' : null, amount: premium }
        },
        serviceFee: serviceFee, taxableSubtotal: taxableSubtotal, salesTax: salesTax, total: total
      };
    }

    function usd(n) { var v = Math.round(Number(n) || 0); return '$' + v.toLocaleString(); }

    function defaultCalcState() {
      var iso = new Date().toISOString().slice(0, 10);
      return {
        eventDate: iso,
        guestCount: Number(LIM.guestDefault) || 40,
        venueStyle: null,
        durationHours: Number(LIM.durDefault) || 4,
        ceremony: false,
        cateringPackage: null, entrees: [], appetizers: [], serviceStyle: 'buffet',
        beveragePackage: LIM.defaultBev || null,
        cateringAddOns: [], floralPackage: null, premiumServices: [],
        name: '', email: '', phone: '', contactMethod: 'Email', notes: ''
      };
    }

    // ---------- helpers ----------
    function esc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    var CHECK_SM_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    function dateLong(iso) {
      if (!iso) return '—';
      try { return new Date(iso).toLocaleDateString(undefined, { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' }); } catch (e) { return iso; }
    }
    function dateShort(iso) {
      if (!iso) return 'Choose a date';
      try { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return iso; }
    }
    function stepNo(i) { var n = (i < 9 ? '0' : '') + (i + 1); return String(C.stepLabelFmt || 'Step {n}').replace('{n}', n); }

    // ---------- state ----------
    var state = defaultCalcState();
    var step = 0;
    var errors = [];

    var mainEl = root.querySelector('[data-calc-main]');
    var panelEl = root.querySelector('[data-calc-panel]');
    var stepperEl = root.querySelector('[data-calc-stepper]');
    var errEl = root.querySelector('[data-calc-errors]');
    var navEl = root.querySelector('[data-calc-nav]');
    var nextBtn = root.querySelector('[data-calc-next]');
    var prevBtn = root.querySelector('[data-calc-prev]');
    var bodyWrap = root.querySelector('.wh-calc__body');
    var stepBar = root.querySelector('.wh-calc__stepbar');
    var successWrap = root.querySelector('[data-calc-success]');
    var successBody = root.querySelector('[data-calc-success-body]');

    var inquiryUrl = root.getAttribute('data-inquiry-url') || '/pages/event-inquiry';
    var tourUrl = root.getAttribute('data-tour-url') || '/pages/book-a-tour';

    navEl.hidden = false; // progressive enhancement: nav only matters once JS runs

    function set(patch) { for (var k in patch) { state[k] = patch[k]; } renderAll(); }
    function toggleList(field, id) {
      var arr = state[field] || [];
      state[field] = arr.indexOf(id) > -1 ? arr.filter(function (x) { return x !== id; }) : arr.concat([id]);
      renderAll();
    }

    function stepHeader(i) {
      var st = STEPS[i] || {};
      return '<div class="wh-calc__sh">' + (st.img ? '<img src="' + esc(st.img) + '" alt="">' : '') + '<div class="wh-calc__sh-scrim"></div>' +
        '<div class="wh-calc__sh-txt"><div class="wh-calc__sh-n">' + stepNo(i) + '</div>' +
        '<div class="wh-calc__sh-t">' + esc(st.title) + '</div><div class="wh-calc__sh-tag">' + esc(st.tag) + '</div></div></div>';
    }
    function rowHead(n, title, hint) {
      return '<div class="wh-calc__row-h"><div class="wh-calc__row-n">' + n + '</div><div><div class="wh-calc__row-t">' + esc(title) + '</div>' +
        (hint ? '<div class="wh-calc__row-hint">' + esc(hint) + '</div>' : '') + '</div></div>';
    }

    // ---------- Step 1: Details ----------
    function renderDetails() {
      var style = find(VENUE_STYLES, state.venueStyle);
      var season = seasonForDate(state.eventDate);
      var h = stepHeader(0);

      h += '<div>' + rowHead('01', C.r1Title, C.r1Hint);
      h += '<input type="date" class="wh-calc__field" data-set="eventDate" value="' + esc(state.eventDate || '') + '">';
      h += '<div class="wh-calc__pill"><span class="wh-calc__season-tag" style="color:' + esc(season.color) + '">' + esc(season.label) + ' Season</span><span class="wh-calc__season-months">' + esc(season.months) + '</span></div>';
      h += '<div class="wh-calc__guide"><div class="wh-overline">' + esc(C.guideTitle) + '</div><div class="wh-calc__guide-grid">';
      SEASONS.forEach(function (sx) {
        h += '<div class="wh-calc__guide-item"><span class="wh-calc__guide-dot" style="background:' + esc(sx.color) + '"></span><div><div class="wh-calc__guide-lbl">' + esc(sx.label) + '</div><div class="wh-calc__guide-note">' + esc(sx.months) + ' — ' + esc(sx.note) + '</div></div></div>';
      });
      h += '</div></div></div>';

      h += '<div>' + rowHead('02', C.r2Title, style ? style.capacity : C.r2Hint);
      h += '<div class="wh-calc__stepper2"><button type="button" class="wh-calc__rndbtn" data-guest="-' + GUEST_STEP + '" aria-label="Decrease guests">' + minusSvg() + '</button>';
      h += '<div class="wh-calc__bignum" data-guest-num>' + state.guestCount + '</div>';
      h += '<button type="button" class="wh-calc__rndbtn" data-guest="' + GUEST_STEP + '" aria-label="Increase guests">' + plusSvg() + '</button><span class="wh-calc__unit">guests</span></div>';
      h += '<input type="range" min="' + GUEST_MIN + '" max="' + GUEST_MAX + '" step="' + GUEST_STEP + '" value="' + state.guestCount + '" class="wh-calc__range" data-guest-range aria-label="' + esc(C.r2Title) + '"></div>';

      h += '<div>' + rowHead('03', C.r3Title, C.r3Hint) + '<div class="wh-calc__styles">';
      VENUE_STYLES.forEach(function (v) {
        var sel = state.venueStyle === v.id;
        var hourly = Math.round(v.hourly * season.mult);
        h += '<button type="button" class="wh-calc__style' + (sel ? ' is-sel' : '') + '" data-style="' + esc(v.id) + '"' + (sel ? ' aria-pressed="true"' : '') + '>';
        h += '<div class="wh-calc__style-img">' + (v.img ? '<img src="' + esc(v.img) + '" alt="' + esc(v.name) + '">' : '') + '<div class="wh-calc__style-scrim"></div>';
        h += '<div class="wh-calc__style-cap"><div><div class="wh-calc__style-name">' + esc(v.name) + '</div><div class="wh-calc__style-room">' + esc(v.room) + '</div></div><div class="wh-calc__style-price">$' + hourly + '/hr</div></div>';
        if (sel) h += '<div class="wh-calc__check">' + CHECK_SVG + '</div>';
        h += '</div><div class="wh-calc__style-body"><p class="wh-calc__style-desc">' + esc(v.description) + '</p><div class="wh-calc__style-meta"><span>' + esc(v.capacity) + '</span><span>·</span><span>' + v.minHours + 'hr min</span>' + (v.weekdayOnly ? '<span>·</span><span style="color:#B7995C">' + esc(C.weekdayLabel || 'Mon–Thu') + '</span>' : '') + '</div></div></button>';
      });
      h += '</div></div>';

      h += '<div>' + rowHead('04', C.r4Title, (style ? style.minHours : 3) + '-hour minimum');
      h += '<div class="wh-calc__stepper2"><button type="button" class="wh-calc__rndbtn" data-dur="-1" aria-label="Decrease hours">' + minusSvg() + '</button>';
      h += '<div class="wh-calc__bignum wh-calc__bignum--sm">' + state.durationHours + '</div>';
      h += '<button type="button" class="wh-calc__rndbtn" data-dur="1" aria-label="Increase hours">' + plusSvg() + '</button><span class="wh-calc__unit">hours</span></div>';
      if (style) {
        var hr = Math.round(style.hourly * season.mult);
        h += '<div class="wh-calc__note-line">$' + hr + '/hr × ' + state.durationHours + ' hours = <span class="wh-calc__accent">' + usd(hr * state.durationHours) + '</span></div>';
      }
      h += '</div>';

      h += '<div>' + rowHead('05', C.r5Title, C.r5Hint);
      h += '<label class="wh-calc__check-row"><input type="checkbox" data-toggle="ceremony"' + (state.ceremony ? ' checked' : '') + '><span>' + esc(C.ceremonyLabel) + '</span></label></div>';
      return h;
    }

    // ---------- Step 2: Catering ----------
    function renderCatering() {
      var pkg = find(CATERING_PACKAGES, state.cateringPackage);
      var h = stepHeader(1);

      h += '<div><div class="wh-overline" style="margin-bottom:14px">' + esc(C.pkgHeading) + '</div><div class="wh-calc__tabs">';
      CATERING_PACKAGES.forEach(function (p) {
        h += '<button type="button" class="wh-calc__tab' + (state.cateringPackage === p.id ? ' is-sel' : '') + '" data-pkg="' + esc(p.id) + '">' + esc(p.name) + '</button>';
      });
      h += '</div></div>';

      if (pkg) {
        var pkgTitle = String(C.pkgTitleFmt || '{name}').replace('{name}', pkg.name);
        h += '<div class="wh-calc__pkg"><div class="wh-calc__pkg-img">' + (pkg.img ? '<img src="' + esc(pkg.img) + '" alt="' + esc(pkg.name) + '">' : '') + '<div class="wh-calc__pkg-scrim"></div>';
        h += '<div class="wh-calc__pkg-cap"><div class="wh-calc__pkg-name">' + esc(pkgTitle) + '</div><div class="wh-calc__pkg-tag">' + esc(pkg.tagline) + '</div></div>';
        if (!pkg.customPricing && !pkg.outside && pkg.priceLabel) h += '<div class="wh-calc__pkg-badge">' + esc(pkg.priceLabel) + '</div>';
        h += '</div><div class="wh-calc__pkg-body"><p class="wh-calc__pkg-desc">' + esc(pkg.description) + '</p><ul class="wh-calc__pkg-list">';
        lines(pkg.includes).forEach(function (i) { h += '<li><span class="wh-calc__diamond"></span><span>' + esc(i) + '</span></li>'; });
        h += '</ul></div></div>';
      }

      // Service style — tiered packages that are not plated-only
      if (pkg && pkg.tiered && !pkg.platedOnly) {
        h += '<div><div class="wh-overline" style="margin-bottom:16px">' + esc(C.styleHeading) + '</div><div class="wh-calc__svc">';
        SERVICE_STYLES.forEach(function (sv) {
          var selS = (state.serviceStyle || 'buffet') === sv.id;
          h += '<button type="button" class="wh-calc__svc-card' + (selS ? ' is-sel' : '') + '" data-svc="' + esc(sv.id) + '" aria-pressed="' + (selS ? 'true' : 'false') + '">';
          h += '<div class="wh-calc__svc-name">' + esc(sv.name) + '</div><div class="wh-calc__svc-note">' + esc(sv.note) + '</div></button>';
        });
        h += '</div></div>';
      }

      if (pkg && pkg.tiered && pkg.platedOnly) {
        h += '<div class="wh-calc__plated">' + esc(C.platedNote) + '</div>';
      }

      // Appetizers — The Mixer
      if (pkg && pkg.appetizerPick) {
        var apps = state.appetizers || [];
        h += '<div><div class="wh-overline" style="margin-bottom:4px">' + esc(C.appHeading) + '</div><div class="wh-calc__subhead" style="margin-bottom:20px">' + esc(C.appSub) + '</div>';
        h += '<div class="wh-calc__apps">';
        APPETIZERS.forEach(function (a) {
          var selA = apps.indexOf(a.id) > -1;
          h += '<button type="button" class="wh-calc__app' + (selA ? ' is-sel' : '') + '" data-app="' + esc(a.id) + '" aria-pressed="' + (selA ? 'true' : 'false') + '">';
          h += '<span class="wh-calc__app-box">' + (selA ? CHECK_SM_SVG : '') + '</span><span class="wh-calc__app-name">' + esc(a.name) + '</span></button>';
        });
        h += '</div>';
        var nApps = apps.length || APPETIZER_DEFAULT_COUNT;
        var appLine = String(C.appLineFmt || '').replace('{n}', nApps).replace('{pp}', APPETIZER_PP).replace('{guests}', state.guestCount);
        h += '<div class="wh-calc__note-line wh-calc__note-line--gold" data-app-line><span class="wh-calc__accent">$' + (APPETIZER_PP * nApps) + '/pp</span> ' + esc(appLine) + '</div>';
        h += '</div>';
      }

      if (pkg && pkg.entreesRequired > 0) {
        var styleKey = pkg.platedOnly ? 'plated' : (state.serviceStyle || 'buffet');
        var famTag = styleKey === 'family' ? ' ' + String(C.entreeFamilyFmt || '').replace('{fee}', FAMILY_STYLE_FEE) : '';
        h += '<div><div class="wh-overline" style="margin-bottom:4px">Choose ' + pkg.entreesRequired + ' Entrées</div><div class="wh-calc__subhead" style="margin-bottom:20px">' + esc(C.entreeSub) + '</div>';
        h += '<div class="wh-calc__entrees">';
        ENTREES.forEach(function (e) {
          var sel = state.entrees.indexOf(e.id) > -1;
          var atLimit = state.entrees.length >= pkg.entreesRequired && !sel;
          var matrix = (PRICE_MATRIX[styleKey === 'family' ? 'buffet' : styleKey] || {})[pkg.id] || {};
          var pp = matrix[e.id];
          h += '<button type="button" class="wh-calc__entree' + (sel ? ' is-sel' : '') + (atLimit ? ' is-disabled' : '') + '" data-entree="' + esc(e.id) + '"' + (atLimit ? ' disabled' : '') + '>';
          h += '<div class="wh-calc__entree-img">' + (e.img ? '<img src="' + esc(e.img) + '" alt="' + esc(e.name) + '">' : '') + '<div class="wh-calc__entree-scrim"></div><div class="wh-calc__entree-cap"><div class="wh-calc__entree-name">' + esc(e.name) + '</div><div class="wh-calc__entree-pp">$' + esc(pp) + '/pp' + esc(famTag) + '</div></div>' + (sel ? '<div class="wh-calc__check">' + CHECK_SVG + '</div>' : '') + '</div>';
          h += '<div class="wh-calc__entree-note">' + esc(e.note) + '</div></button>';
        });
        h += '</div>';
        if (state.entrees.length > 0) {
          var avg = Math.round(entreeAvgFor(pkg.id, styleKey, state.entrees));
          var famAvg = (state.serviceStyle === 'family' && !pkg.platedOnly) ? ' ' + String(C.avgFamilyFmt || '').replace('{fee}', FAMILY_STYLE_FEE) : '';
          h += '<div class="wh-calc__note-line wh-calc__note-line--gold" data-avg-line>Avg entrée: <span class="wh-calc__accent">$' + avg + '/pp</span> × ' + state.guestCount + ' guests' + esc(famAvg) + '</div>';
        }
        h += '</div>';
      }
      return h;
    }

    // ---------- Step 3: Beverages ----------
    function renderBeverages() {
      var h = stepHeader(2);
      h += '<div class="wh-calc__bevs">';
      BEVERAGE_PACKAGES.forEach(function (b) {
        var sel = state.beveragePackage === b.id;
        h += '<button type="button" class="wh-calc__bev' + (sel ? ' is-sel' : '') + '" data-bev="' + esc(b.id) + '"><div class="wh-calc__radio"><span></span></div>';
        h += '<div><div class="wh-calc__bev-name">' + esc(b.name) + '</div><div class="wh-calc__bev-note">' + esc(b.note) + '</div></div><div class="wh-calc__bev-price">';
        if (b.pp > 0) h += '<div class="wh-calc__bev-pp">$' + b.pp + '/pp</div><div class="wh-calc__bev-total">' + usd(b.pp * state.guestCount) + ' total</div>';
        else h += '<div class="wh-calc__bev-total" style="text-transform:uppercase;letter-spacing:.14em">None</div>';
        h += '</div></button>';
      });
      h += '</div>';

      h += '<div><div class="wh-overline" style="margin-bottom:14px">' + esc(C.addonHeading) + '</div><div class="wh-calc__addons">';
      CATERING_ADDONS.forEach(function (a) {
        var sel = state.cateringAddOns.indexOf(a.id) > -1;
        var price = a.flat ? '+' + usd(a.flat) : '+$' + a.pp + (a.unit || '');
        h += '<label class="wh-calc__addon' + (sel ? ' is-sel' : '') + '"><input type="checkbox" data-addon="' + esc(a.id) + '"' + (sel ? ' checked' : '') + '><span class="wh-calc__addon-name">' + esc(a.name) + '</span><span class="wh-calc__addon-price">' + esc(price) + '</span></label>';
      });
      h += '</div></div>';
      return h;
    }

    // ---------- Step 4: Add-Ons ----------
    function renderAddOns() {
      var h = stepHeader(3);
      h += '<div><div class="wh-overline" style="margin-bottom:4px">' + esc(C.floralHeading) + '</div><div class="wh-calc__subhead" style="margin-bottom:16px">' + esc(C.floralSub) + '</div>';
      h += '<div class="wh-calc__florals">';
      FLORAL_PACKAGES.forEach(function (f) {
        var sel = state.floralPackage === f.id;
        h += '<button type="button" class="wh-calc__floral' + (sel ? ' is-sel' : '') + '" data-floral="' + esc(f.id) + '"><div class="wh-calc__floral-img">' + (f.img ? '<img src="' + esc(f.img) + '" alt="' + esc(f.name) + '">' : '') + (sel ? '<div class="wh-calc__check">' + CHECK_SVG + '</div>' : '') + '</div>';
        h += '<div class="wh-calc__floral-body"><div class="wh-calc__floral-name">' + esc(f.name) + '</div><ul class="wh-calc__floral-list">';
        lines(f.bullets).forEach(function (b) { h += '<li><span class="wh-calc__diamond"></span>' + esc(b) + '</li>'; });
        h += '</ul><div class="wh-calc__floral-price">' + usd(f.price) + '</div></div></button>';
      });
      h += '</div>';
      if (!state.floralPackage) h += '<div class="wh-calc__note-line" style="text-align:center;text-transform:uppercase;letter-spacing:.18em;color:#7C776E">' + esc(C.floralNone) + '</div>';
      h += '</div>';

      h += '<div><div class="wh-overline" style="margin-bottom:4px">' + esc(C.premiumHeading) + '</div><div class="wh-calc__subhead" style="margin-bottom:16px">' + esc(C.premiumSub) + '</div>';
      h += '<div class="wh-calc__premium">';
      PREMIUM_SERVICES.forEach(function (p) {
        var sel = state.premiumServices.indexOf(p.id) > -1;
        h += '<div class="wh-calc__prem"><div class="wh-calc__prem-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '">' : '') + '<div class="wh-calc__prem-badge">non-taxable</div></div>';
        h += '<div class="wh-calc__prem-body"><div class="wh-calc__prem-name">' + esc(p.name) + '</div><p class="wh-calc__prem-desc">' + esc(p.description) + '</p><div class="wh-calc__prem-foot"><div class="wh-calc__prem-price">' + usd(p.price) + '</div>';
        h += '<button type="button" class="' + (sel ? 'wh-btn-gold' : 'wh-btn-quiet') + ' wh-calc__miniadd" data-premium="' + esc(p.id) + '">' + (sel ? 'Added' : 'Add') + '</button></div></div></div>';
      });
      h += '</div></div>';
      return h;
    }

    // ---------- Step 5: Review ----------
    function sumCard(title, editIdx, rows) {
      var h = '<div class="wh-calc__sum"><div class="wh-calc__sum-h"><div class="wh-calc__sum-t">' + esc(title) + '</div><button type="button" class="wh-calc__sum-edit" data-goto="' + editIdx + '">' + editSvg() + ' Edit</button></div><div class="wh-calc__sum-rows">';
      rows.forEach(function (r) {
        if (!r) return;
        var cls = r.strong ? 'wh-calc__sum-val wh-calc__sum-val--strong' : 'wh-calc__sum-val';
        h += '<div class="wh-calc__sum-row"><span class="wh-calc__sum-lbl">' + esc(r.label) + '</span><span class="' + cls + '">' + esc(r.value) + '</span></div>';
      });
      return h + '</div></div>';
    }

    function renderReview() {
      var q = computeQuote(state);
      var season = seasonForDate(state.eventDate);
      var h = stepHeader(4);

      h += '<div class="wh-calc__sumgrid">';
      h += sumCard(STEPS[0].label, 0, [
        { label: 'Date', value: dateLong(state.eventDate) },
        { label: 'Season', value: season.label },
        { label: 'Guests', value: state.guestCount + ' guests' },
        { label: 'Duration', value: state.durationHours + ' hours' },
        { label: 'Venue Style', value: q.style ? q.style.name : '—' },
        { label: 'Ceremony', value: state.ceremony ? C.ceremonySummary : 'No' },
        { label: 'Venue Rental', value: usd(q.lines.venue.amount), strong: true }
      ]);
      var entreeNames = ENTREES.filter(function (e) { return state.entrees.indexOf(e.id) > -1; }).map(function (e) { return e.name; }).join(', ');
      var appList = state.appetizers || [];
      var appNames = APPETIZERS.filter(function (a) { return appList.indexOf(a.id) > -1; }).map(function (a) { return a.name; }).join(', ');
      h += sumCard(STEPS[1].label, 1, [
        { label: 'Package', value: q.cateringPkg ? q.cateringPkg.name : '—' },
        (q.cateringPkg && q.cateringPkg.tiered) ? { label: C.sumStyleLabel, value: serviceStyleName(q.cateringPkg, state.serviceStyle) } : null,
        state.entrees.length > 0 ? { label: 'Entrées', value: entreeNames } : null,
        appList.length > 0 ? { label: C.sumAppLabel, value: appNames } : null,
        { label: state.guestCount + ' guests', value: usd(q.lines.catering.amount), strong: true }
      ]);
      var addonNames = state.cateringAddOns.map(function (id) { var a = find(CATERING_ADDONS, id); return a ? a.name : null; }).filter(Boolean).join(', ');
      h += sumCard(STEPS[2].label, 2, [
        { label: 'Package', value: q.beverage ? q.beverage.name : '—' },
        state.cateringAddOns.length > 0 ? { label: 'Add-Ons', value: addonNames } : null,
        { label: 'Subtotal', value: usd(q.lines.beverage.amount + q.lines.addOns.amount), strong: true }
      ]);
      var premNames = state.premiumServices.map(function (id) { var p = find(PREMIUM_SERVICES, id); return p ? p.name : null; }).filter(Boolean).join(', ');
      h += sumCard(STEPS[3].label, 3, [
        { label: 'Florals', value: q.floral ? q.floral.name + ' — ' + usd(q.floral.price) : 'None' },
        { label: 'Premium Services', value: state.premiumServices.length ? premNames : 'None' }
      ]);
      h += '</div>';

      h += '<div class="wh-calc__break"><div class="wh-overline">' + esc(C.breakdownHeading) + '</div><ul class="wh-calc__break-list">';
      [['Venue Rental', q.lines.venue.amount],
       [(q.cateringPkg ? q.cateringPkg.name + ' Catering' : 'Catering'), q.lines.catering.amount],
       [(q.beverage ? q.beverage.name : 'Beverage'), q.lines.beverage.amount],
       ['Catering Add-Ons', q.lines.addOns.amount],
       ['Ceremony', q.lines.ceremony.amount],
       ['Florals', q.lines.florals.amount]].forEach(function (row) {
        if (row[1] > 0) h += '<li class="wh-calc__break-line"><span class="wh-calc__lbl">' + esc(row[0]) + '</span><span class="wh-calc__amt">' + usd(row[1]) + '</span></li>';
      });
      h += '<li style="padding-top:8px"><span class="wh-calc__sub">' + esc(RATES.serviceLabel) + '</span><span class="wh-calc__sub">' + usd(q.serviceFee) + '</span></li>';
      h += '<li><span class="wh-calc__sub">Taxable Subtotal</span><span class="wh-calc__sub">' + usd(q.taxableSubtotal) + '</span></li>';
      h += '<li><span class="wh-calc__sub">' + esc(RATES.taxLabel) + '</span><span class="wh-calc__sub">' + usd(q.salesTax) + '</span></li>';
      if (q.lines.premium.amount > 0) h += '<li><span class="wh-calc__sub">Premium Services (non-taxable)</span><span class="wh-calc__sub">' + usd(q.lines.premium.amount) + '</span></li>';
      h += '</ul><div class="wh-calc__break-total"><div class="wh-overline">' + esc(C.grandTotalLabel) + '</div><div class="wh-calc__total" data-total>' + usd(q.total) + '</div></div></div>';

      h += '<div class="wh-calc__contact"><div class="wh-overline" style="margin-bottom:8px">' + esc(C.contactHeading) + '</div><div class="wh-calc__subhead">' + esc(C.contactSub) + '</div>';
      h += '<div class="wh-calc__form">';
      h += '<div><label class="wh-calc__lbl-t" for="wh-calc-name">Full Name *</label><input id="wh-calc-name" class="wh-calc__field wh-calc__field--full" data-set-raw="name" value="' + esc(state.name) + '" placeholder="Your full name"></div>';
      h += '<div><label class="wh-calc__lbl-t" for="wh-calc-email">Email Address *</label><input id="wh-calc-email" type="email" class="wh-calc__field wh-calc__field--full" data-set-raw="email" value="' + esc(state.email) + '" placeholder="you@example.com"></div>';
      h += '<div><label class="wh-calc__lbl-t" for="wh-calc-phone">Phone Number *</label><input id="wh-calc-phone" class="wh-calc__field wh-calc__field--full" data-set-raw="phone" value="' + esc(state.phone) + '" placeholder="(530) 000-0000"></div>';
      h += '<div><label class="wh-calc__lbl-t" for="wh-calc-cm">Preferred Contact Method</label><select id="wh-calc-cm" class="wh-calc__field wh-calc__field--full" data-set-raw="contactMethod"><option' + (state.contactMethod === 'Email' ? ' selected' : '') + '>Email</option><option' + (state.contactMethod === 'Phone' ? ' selected' : '') + '>Phone</option><option' + (state.contactMethod === 'Text' ? ' selected' : '') + '>Text</option></select></div>';
      h += '<div class="wh-calc__form-full"><label class="wh-calc__lbl-t" for="wh-calc-notes">Additional Notes</label><textarea id="wh-calc-notes" class="wh-calc__field wh-calc__field--full" rows="4" data-set-raw="notes" placeholder="Special requests, dietary restrictions, or questions…">' + esc(state.notes) + '</textarea></div>';
      h += '</div></div>';
      return h;
    }

    // ---------- Quote panel (port of QuotePanel.jsx) ----------
    function renderPanel() {
      var q = computeQuote(state);
      var season = seasonForDate(state.eventDate);
      var guests = state.guestCount || 0;
      var hours = q.hours || state.durationHours || 4;
      var h = '<div class="wh-overline">' + esc(C.panelHeading) + '</div>';
      h += '<div class="wh-calc__meta">' + calSvg() + '<span>' + esc(dateShort(state.eventDate)) + '</span><span class="wh-calc__meta-tag" style="color:' + esc(season.color) + '">' + esc(season.label) + '</span></div>';
      h += '<div class="wh-calc__meta">' + usersSvg() + '<span>' + guests + ' guests · ' + hours + ' hrs</span></div>';
      h += '<div class="wh-calc__hr"></div>';

      if (!q.style && !q.cateringPkg) {
        h += '<div class="wh-calc__empty">' + esc(C.panelEmpty) + '</div>';
      } else {
        var ls = [q.lines.venue, q.lines.catering, q.lines.beverage, q.lines.addOns, q.lines.ceremony, q.lines.florals]
          .filter(function (l) { return l && l.label && l.amount > 0; });
        h += '<ul class="wh-calc__lines">';
        ls.forEach(function (l) { h += '<li><span class="wh-calc__lbl">' + esc(l.label) + '</span><span class="wh-calc__amt">' + usd(l.amount) + '</span></li>'; });
        h += '</ul>';
        if (q.serviceFee > 0 || q.salesTax > 0) {
          h += '<div class="wh-calc__hr"></div><ul class="wh-calc__subs">';
          if (q.serviceFee > 0) h += '<li><span>' + esc(RATES.serviceLabel) + '</span><span>' + usd(q.serviceFee) + '</span></li>';
          h += '<li><span>Taxable Subtotal</span><span>' + usd(q.taxableSubtotal) + '</span></li>';
          h += '<li><span>' + esc(RATES.taxLabel) + '</span><span>' + usd(q.salesTax) + '</span></li>';
          if (q.lines.premium.amount > 0) h += '<li><span>Premium Services</span><span>' + usd(q.lines.premium.amount) + '</span></li>';
          h += '</ul>';
        }
        h += '<div class="wh-calc__totalrow"><div class="wh-overline">' + esc(C.panelTotalLabel) + '</div><div class="wh-calc__total" data-panel-total>' + usd(q.total) + '</div></div>';
      }
      h += '<div class="wh-calc__aside-fine">' + esc(C.panelFine) + '</div>';
      panelEl.innerHTML = h;
    }

    // ---------- Stepper ----------
    function renderStepper() {
      var h = '';
      STEPS.forEach(function (st, i) {
        var cls = i === step ? ' is-active' : (i < step ? ' is-done' : '');
        h += '<button type="button" class="wh-calc__step' + cls + '" data-goto="' + i + '"' + (i === step ? ' aria-current="step"' : '') + '><div class="wh-calc__dot">' + (i < step ? CHECK_SVG : (i + 1)) + '</div><div class="wh-calc__steplabel">' + esc(st.label) + '</div></button>';
        if (i < STEPS.length - 1) h += '<div class="wh-calc__stepline' + (i < step ? ' is-done' : '') + '"></div>';
      });
      stepperEl.innerHTML = h;
    }

    function renderErrors() {
      if (!errors.length) { errEl.hidden = true; errEl.innerHTML = ''; return; }
      errEl.hidden = false;
      errEl.innerHTML = errors.map(function (e) { return '<div class="wh-calc__err">· ' + esc(e) + '</div>'; }).join('');
    }
    function renderNav() {
      prevBtn.disabled = step === 0;
      if (step < STEPS.length - 1) { nextBtn.disabled = false; nextBtn.innerHTML = 'Continue to ' + esc(STEPS[step + 1].label) + ' ' + chevRight(); }
      else { nextBtn.disabled = saving; nextBtn.innerHTML = sendSvg() + ' ' + esc(saving ? SUB.sendingLabel : SUB.submitLabel); }
    }

    var lastTotal = 0;
    function renderStep() {
      var h = '';
      if (step === 0) h = renderDetails();
      else if (step === 1) h = renderCatering();
      else if (step === 2) h = renderBeverages();
      else if (step === 3) h = renderAddOns();
      else h = renderReview();
      mainEl.innerHTML = '<div class="wh-calc__step-inner">' + h + '</div>';
      if (step === 4) countUpTotal();
    }
    function renderAll() { renderStepper(); renderStep(); renderPanel(); renderErrors(); renderNav(); }

    function countUpTotal() {
      var el = mainEl.querySelector('[data-total]');
      if (!el) return;
      var target = Math.round(computeQuote(state).total);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || target === lastTotal) { el.textContent = usd(target); lastTotal = target; return; }
      var start = lastTotal, t0 = null, dur = 600;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = usd(start + (target - start) * eased);
        if (p < 1) requestAnimationFrame(frame); else { el.textContent = usd(target); lastTotal = target; }
      }
      requestAnimationFrame(frame);
    }

    // ---------- Validation ----------
    function validateStep() {
      var e = [];
      if (step === 0) {
        if (!state.eventDate) e.push('Please select an event date.');
        if (!state.venueStyle) e.push('Please select an event style.');
        if (!state.guestCount || state.guestCount < GUEST_MIN) e.push('Guest count must be at least ' + GUEST_MIN + '.');
      }
      if (step === 1) {
        if (!state.cateringPackage) e.push('Please choose a catering package.');
        var pkg = find(CATERING_PACKAGES, state.cateringPackage);
        if (pkg && pkg.entreesRequired > 0 && state.entrees.length !== pkg.entreesRequired) e.push('Please choose ' + pkg.entreesRequired + ' entrées.');
      }
      if (step === 2) { if (!state.beveragePackage) e.push('Please choose a beverage option.'); }
      if (step === 4) {
        if (!state.name) e.push('Full name is required.');
        if (!state.email) e.push('Email address is required.');
        if (!state.phone) e.push('Phone number is required.');
      }
      errors = e;
      renderErrors();
      return e.length === 0;
    }

    function goNext() {
      if (!validateStep()) return;
      if (step === STEPS.length - 1) { submit(); return; }
      step = Math.min(STEPS.length - 1, step + 1); errors = []; renderAll(); scrollTop();
    }
    function goPrev() { step = Math.max(0, step - 1); errors = []; renderAll(); scrollTop(); }
    function goToStep(i) { step = i; errors = []; renderAll(); scrollTop(); }
    function scrollTop(el) {
      el = el || bodyWrap;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
    }

    // ---------- Submit (port of EventCalculator.jsx submit()) ----------
    // Payload: EXACTLY the object the live React app posts to <backend>/api/calculator.
    function buildPayload(quote) {
      return {
        event_type: (quote.style && quote.style.name) || 'Event',
        guest_count: Number(state.guestCount) || 0,
        service_style: state.venueStyle || '',
        beverage_tier: state.beveragePackage || '',
        menu_tier: state.cateringPackage || '',
        private_or_full: state.venueStyle || '',
        ceremony: !!state.ceremony,
        add_ons: state.cateringAddOns || [],
        estimate_low: Math.round(quote.total * 0.95),
        estimate_high: Math.round(quote.total * 1.05),
        recommended_package: (quote.cateringPkg && quote.cateringPkg.name) || '',
        recommended_space: (quote.style && quote.style.room) || '',
        contact_email: state.email,
        contact_name: state.name,
        notes: state.notes,
        // extended
        event_date: state.eventDate,
        duration_hours: Number(state.durationHours) || null,
        season: seasonForDate(state.eventDate).key,
        venue_style: state.venueStyle,
        catering_package: state.cateringPackage,
        entrees: state.entrees || [],
        appetizers: state.appetizers || [],
        service_style_catering: state.serviceStyle || 'buffet',
        beverage_package: state.beveragePackage,
        catering_add_ons: state.cateringAddOns || [],
        floral_package: state.floralPackage,
        premium_services: state.premiumServices || [],
        venue_cost: Math.round(quote.lines.venue.amount),
        catering_cost: Math.round(quote.lines.catering.amount),
        beverage_cost: Math.round(quote.lines.beverage.amount),
        add_ons_cost: Math.round(quote.lines.addOns.amount),
        floral_cost: Math.round(quote.lines.florals.amount),
        premium_cost: Math.round(quote.lines.premium.amount),
        service_fee: Math.round(quote.serviceFee),
        sales_tax: Math.round(quote.salesTax),
        estimated_total: Math.round(quote.total),
        contact_phone: state.phone,
        preferred_contact_method: state.contactMethod
      };
    }

    var saving = false;
    function submit() {
      if (saving) return;
      var q = computeQuote(state);
      var payload = buildPayload(q);
      saving = true; renderNav();
      var req = SUB.endpoint
        ? fetchWithTimeout(SUB.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }, 15000)
            .then(function (r) { if (!r.ok) throw new Error('quote service HTTP ' + r.status); return r; })
        : Promise.reject(new Error('no quote endpoint configured'));
      req['catch'](function () {
        // Quote service unreachable (e.g. asleep): the lead still counts as sent if Shopify's contact form takes it.
        return sendFallback(q);
      }).then(function () {
        toast(SUB.toastSuccess, 'success');
      }, function () {
        toast(SUB.toastError, 'error');
      }).then(function () {
        showSuccess(); // the summary shows either way (React does setSubmitted(true) in the catch)
        saving = false; renderNav();
      });
    }
    function fetchWithTimeout(url, opts, ms) {
      if (typeof AbortController === 'undefined') return fetch(url, opts);
      var ctl = new AbortController();
      var timer = setTimeout(function () { ctl.abort(); }, ms);
      opts.signal = ctl.signal;
      return fetch(url, opts).then(function (r) { clearTimeout(timer); return r; }, function (e) { clearTimeout(timer); throw e; });
    }

    // Safety net: the quote service failed, so hand the full lead to Shopify's contact form.
    function leadSummary(q) {
      var season = seasonForDate(state.eventDate);
      var L = [];
      function add(k, v) { L.push(k + ': ' + (v == null || v === '' ? '—' : v)); }
      L.push(SUB.fallbackHeading || '');
      L.push('');
      add('Name', state.name); add('Email', state.email); add('Phone', state.phone); add('Preferred contact', state.contactMethod);
      L.push('');
      add('Event date', state.eventDate + ' (' + season.label + ')');
      add('Guests', state.guestCount);
      add('Duration', state.durationHours + ' hours');
      add('Venue style', q.style ? q.style.name + ' — ' + q.style.room : '—');
      add('Ceremony', state.ceremony ? C.ceremonySummary : 'No');
      L.push('');
      add('Catering package', q.cateringPkg ? q.cateringPkg.name : '—');
      if (q.cateringPkg && q.cateringPkg.tiered) add('Service style', serviceStyleName(q.cateringPkg, state.serviceStyle));
      if (state.entrees.length) add('Entrées', ENTREES.filter(function (e) { return state.entrees.indexOf(e.id) > -1; }).map(function (e) { return e.name; }).join(', '));
      if ((state.appetizers || []).length) add('Appetizers', APPETIZERS.filter(function (a) { return state.appetizers.indexOf(a.id) > -1; }).map(function (a) { return a.name; }).join(', '));
      add('Beverage', q.beverage ? q.beverage.name : '—');
      if (state.cateringAddOns.length) add('Catering add-ons', state.cateringAddOns.map(function (id) { var a = find(CATERING_ADDONS, id); return a ? a.name : id; }).join(', '));
      add('Florals', q.floral ? q.floral.name : 'None');
      add('Premium services', state.premiumServices.length ? state.premiumServices.map(function (id) { var p = find(PREMIUM_SERVICES, id); return p ? p.name : id; }).join(', ') : 'None');
      L.push('');
      L.push('Estimate breakdown');
      [q.lines.venue, q.lines.catering, q.lines.beverage, q.lines.addOns, q.lines.ceremony, q.lines.florals].forEach(function (l) {
        if (l && l.label && l.amount > 0) L.push('  ' + l.label + ': ' + usd(l.amount));
      });
      L.push('  ' + RATES.serviceLabel + ': ' + usd(q.serviceFee));
      L.push('  Taxable Subtotal: ' + usd(q.taxableSubtotal));
      L.push('  ' + RATES.taxLabel + ': ' + usd(q.salesTax));
      if (q.lines.premium.amount > 0) L.push('  ' + q.lines.premium.label + ': ' + usd(q.lines.premium.amount));
      L.push('  ' + (C.grandTotalLabel || 'Estimated Grand Total') + ': ' + usd(q.total));
      L.push('  Planning range: ' + usd(q.total * 0.95) + ' – ' + usd(q.total * 1.05));
      L.push('');
      add('Notes', state.notes);
      return L.join('\n');
    }
    // Resolves once Shopify has accepted the contact post (it redirects with contact_posted=true), rejects otherwise.
    var fbPending = null; // { resolve, reject } of the contact post in flight
    function sendFallback(q) {
      var form = root.querySelector('.wh-calc__contactform');
      if (!SUB.fallbackContact || !form) return Promise.reject(new Error('contact fallback off'));
      return new Promise(function (resolve, reject) {
        var done = false;
        var finish = function (ok, err) { if (done) return; done = true; fbPending = null; ok ? resolve() : reject(err); };
        fbPending = { resolve: function () { finish(true); }, reject: function (e) { finish(false, e); } };
        // A visible hCaptcha challenge may need the visitor for a while, but never leave them waiting forever.
        setTimeout(function () { finish(false, new Error('contact fallback timed out')); }, 120000);

        var vals = { name: state.name, email: state.email, phone: state.phone, body: leadSummary(q) };
        Array.prototype.forEach.call(form.querySelectorAll('[data-fb]'), function (inp) { inp.value = vals[inp.getAttribute('data-fb')] || ''; });
        var cap = window.Shopify && window.Shopify.captcha;
        if (!cap || typeof cap.protect !== 'function') { postContactForm(form); return; }
        if (form.getAttribute('data-calc-captcha') === '1') { form.submit(); return; }
        form.setAttribute('data-calc-captcha', '1');
        // Shopify's captcha wrapper captures form.submit when it binds and calls it once the hCaptcha
        // token is on the form, so this fetch is what finally posts (and the page never navigates).
        form.submit = function () { postContactForm(form); };
        try { cap.protect(form, function () { form.submit(); }); } catch (e) { postContactForm(form); }
      });
    }
    function postContactForm(form) {
      var action = (form.getAttribute('action') || '/contact').split('#')[0];
      fetch(action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(function (r) {
        if (!fbPending) return;
        if (r.ok && /contact_posted=true/.test(r.url)) fbPending.resolve();
        else fbPending.reject(new Error('contact form HTTP ' + r.status));
      }, function (e) { if (fbPending) fbPending.reject(e); });
    }

    // ---------- Toast (sonner-style) ----------
    var toastsEl = root.querySelector('[data-calc-toasts]');
    function toast(msg, kind) {
      if (!toastsEl || !msg) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      toastsEl.innerHTML = '';
      var t = document.createElement('div');
      t.className = 'wh-calc__toast wh-calc__toast--' + kind;
      t.setAttribute('data-calc-toast', kind);
      t.innerHTML = '<span class="wh-calc__toast-ic">' + (kind === 'error' ? alertSvg() : okSvg()) + '</span><span class="wh-calc__toast-msg">' + esc(msg) + '</span>' +
        '<button type="button" class="wh-calc__toast-x" aria-label="' + esc(SUB.toastClose || '') + '">' + xSvg() + '</button>';
      toastsEl.appendChild(t);
      var gone = false;
      function dismiss() {
        if (gone) return; gone = true;
        t.classList.remove('is-in');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, reduce ? 0 : 360);
      }
      t.querySelector('.wh-calc__toast-x').addEventListener('click', dismiss);
      requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-in'); }); });
      setTimeout(dismiss, 4000);
    }

    function showSuccess() {
      var q = computeQuote(state);
      bodyWrap.hidden = true;
      successWrap.hidden = false;
      var first = (state.name.split(' ')[0]) || C.successFriend || '';
      var h = '<div class="wh-overline">' + esc(C.successOverline) + '</div>';
      h += '<div class="wh-calc__success-total" data-success-total>' + usd(q.total) + '</div>';
      h += '<div class="wh-calc__success-sub">' + esc(C.successTotalLabel) + '</div>';
      h += '<p class="wh-calc__success-msg">' + esc(String(C.successMsg || '').replace('{name}', first)) + '</p>';
      h += '<div class="wh-calc__success-grid"><div class="wh-calc__success-cell"><div class="wh-overline">' + esc(C.successPkgLabel) + '</div><div class="wh-calc__success-cell-t">' + esc(q.cateringPkg ? q.cateringPkg.name : '—') + '</div></div>';
      h += '<div class="wh-calc__success-cell"><div class="wh-overline">' + esc(C.successSpaceLabel) + '</div><div class="wh-calc__success-cell-t">' + esc(q.style ? q.style.room : '—') + '</div></div></div>';
      h += '<div class="wh-calc__success-cta"><a class="wh-btn-gold" href="' + esc(inquiryUrl) + '">' + sparkSvg() + ' ' + esc(C.successCta1) + '</a>';
      h += '<a class="wh-btn-quiet" href="' + esc(tourUrl) + '">' + esc(C.successCta2) + '</a>';
      h += '<button type="button" class="wh-btn-quiet" data-reset>' + esc(C.successReset) + '</button></div>';
      successBody.innerHTML = h;
      scrollTop(successWrap);
    }

    // ---------- SVG helpers ----------
    function minusSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line></svg>'; }
    function plusSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>'; }
    function chevRight() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>'; }
    function editSvg() { return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>'; }
    function sendSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>'; }
    function sparkSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9Z"></path></svg>'; }
    function calSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>'; }
    function okSvg() { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><polyline points="16 9 10.5 15 8 12.5"></polyline></svg>'; }
    function alertSvg() { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'; }
    function xSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'; }
    function usersSvg() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>'; }

    // ---------- Events ----------
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-goto],[data-style],[data-pkg],[data-svc],[data-app],[data-entree],[data-bev],[data-floral],[data-premium],[data-guest],[data-dur],[data-reset]');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-reset')) {
        state = defaultCalcState(); step = 0; errors = []; lastTotal = 0;
        successWrap.hidden = true; bodyWrap.hidden = false; stepBar.hidden = false;
        renderAll(); scrollTop(); return;
      }
      if (t.hasAttribute('data-goto')) { goToStep(parseInt(t.getAttribute('data-goto'), 10)); return; }
      if (t.hasAttribute('data-style')) {
        var v = find(VENUE_STYLES, t.getAttribute('data-style'));
        set({ venueStyle: t.getAttribute('data-style'), durationHours: Math.max(state.durationHours || 4, v ? v.minHours : 4) });
        return;
      }
      if (t.hasAttribute('data-pkg')) { set({ cateringPackage: t.getAttribute('data-pkg'), entrees: [], appetizers: [], serviceStyle: 'buffet' }); return; }
      if (t.hasAttribute('data-svc')) { set({ serviceStyle: t.getAttribute('data-svc') }); return; }
      if (t.hasAttribute('data-app')) { toggleList('appetizers', t.getAttribute('data-app')); return; }
      if (t.hasAttribute('data-entree')) {
        var pkg = find(CATERING_PACKAGES, state.cateringPackage);
        var id = t.getAttribute('data-entree');
        var sel = state.entrees.indexOf(id) > -1;
        if (pkg && state.entrees.length >= pkg.entreesRequired && !sel) return;
        toggleList('entrees', id); return;
      }
      if (t.hasAttribute('data-bev')) { set({ beveragePackage: t.getAttribute('data-bev') }); return; }
      if (t.hasAttribute('data-floral')) {
        var fid = t.getAttribute('data-floral');
        set({ floralPackage: state.floralPackage === fid ? null : fid }); return;
      }
      if (t.hasAttribute('data-premium')) { toggleList('premiumServices', t.getAttribute('data-premium')); return; }
      if (t.hasAttribute('data-guest')) {
        var g = (state.guestCount || GUEST_MIN) + parseInt(t.getAttribute('data-guest'), 10);
        set({ guestCount: Math.min(GUEST_MAX, Math.max(GUEST_MIN, g)) }); return;
      }
      if (t.hasAttribute('data-dur')) {
        var st = find(VENUE_STYLES, state.venueStyle);
        var mn = (st && st.minHours) || 3;
        set({ durationHours: Math.min(DUR_MAX, Math.max(mn, (state.durationHours || 4) + parseInt(t.getAttribute('data-dur'), 10))) }); return;
      }
    });

    root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t.hasAttribute) return;
      if (t.hasAttribute('data-toggle')) { set({ ceremony: t.checked }); return; }
      if (t.hasAttribute('data-addon')) { toggleList('cateringAddOns', t.getAttribute('data-addon')); return; }
      if (t.hasAttribute('data-set')) { var patch = {}; patch[t.getAttribute('data-set')] = t.value; set(patch); return; }
      if (t.hasAttribute('data-guest-range')) { set({ guestCount: Number(t.value) }); return; }
      if (t.hasAttribute('data-set-raw')) { state[t.getAttribute('data-set-raw')] = t.value; }
    });

    root.addEventListener('input', function (ev) {
      var t = ev.target;
      if (!t.hasAttribute) return;
      if (t.hasAttribute('data-guest-range')) {
        state.guestCount = Number(t.value);
        var num = mainEl.querySelector('[data-guest-num]');
        if (num) num.textContent = state.guestCount;
        renderPanel();
        return;
      }
      if (t.hasAttribute('data-set-raw')) { state[t.getAttribute('data-set-raw')] = t.value; }
    });

    nextBtn.addEventListener('click', goNext);
    prevBtn.addEventListener('click', goPrev);

    // Expose a tiny hook so QA can drive the wizard headlessly.
    root.whCalc = {
      get state() { return state; },
      set: function (patch) { set(patch); },
      goToStep: goToStep,
      quote: function () { return computeQuote(state); },
      payload: function () { return buildPayload(computeQuote(state)); }
    };

    renderAll(); // collapses the shipped-visible static steps into the wizard
    return true;
  }
  if (!boot()) document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-wh-faq]');
  if (!root) return;
  var search = root.querySelector('[data-wh-faq-search]');
  var cats = root.querySelectorAll('[data-wh-faq-cat]');
  var items = root.querySelectorAll('[data-wh-faq-item]');
  var empty = root.querySelector('[data-wh-faq-empty]');
  var activeCat = 'All';
  function apply() {
    var q = (search.value || '').trim().toLowerCase();
    var shown = 0;
    items.forEach(function (it) {
      var inCat = activeCat === 'All' || it.getAttribute('data-cat') === activeCat;
      var text = it.textContent.toLowerCase();
      var inQ = !q || text.indexOf(q) !== -1;
      var show = inCat && inQ;
      if (show) { it.removeAttribute('hidden'); shown++; } else { it.setAttribute('hidden', ''); }
    });
    if (empty) empty.hidden = shown !== 0;
  }
  search.addEventListener('input', apply);
  cats.forEach(function (b) {
    b.addEventListener('click', function () {
      cats.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      activeCat = b.getAttribute('data-wh-faq-cat');
      apply();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.wh-header')) || document.querySelector('.wh-header');
  if (!s) return;
  function onScroll(){ s.classList.toggle('is-scrolled', window.scrollY > 24); }
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  var toggle = s.querySelector('[data-wh-drawer-toggle]');
  var drawer = s.querySelector('[data-wh-drawer]');
  var iconOpen = s.querySelector('[data-wh-icon-open]');
  var iconClose = s.querySelector('[data-wh-icon-close]');
  var openLabel = toggle && (toggle.getAttribute('data-wh-open-label') || 'Open menu');
  var closeLabel = toggle && (toggle.getAttribute('data-wh-close-label') || 'Close menu');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.hasAttribute('hidden');
      if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      if (iconOpen && iconClose) {
        if (open) { iconOpen.setAttribute('hidden', ''); iconClose.removeAttribute('hidden'); }
        else { iconClose.setAttribute('hidden', ''); iconOpen.removeAttribute('hidden'); }
      }
    });
  }
  // tap-to-open megas on touch
  s.querySelectorAll('[data-wh-mega]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var panel = s.querySelector('[data-wh-mega-panel="' + btn.getAttribute('data-wh-mega') + '"]');
        s.querySelectorAll('.wh-mega').forEach(function (p){ if (p !== panel) p.classList.remove('is-open'); });
        if (panel) panel.classList.toggle('is-open');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
